export const ADVISOR_SETTINGS_RECEIVED = 'ADVISOR_SETTINGS_RECEIVED'
export const ADVISOR_DETAILS_RECEIVED = 'ADVISOR_DETAILS_RECEIVED'